
import { AxiosError, AxiosResponse } from 'axios';
import Vue from 'vue';
import { VueConstructor } from 'vue/types/vue';
import QueueStatus from '@/models/queueStatus';
import bus from '@/main';
import { EntityStatus } from '@/models/enums';
import UserState from '@/store/user/userState';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';

const Queues = (Vue as VueConstructor<Vue & UserState>).extend({
  data() {
    return {
      queues: [] as QueueStatus[],
      queuesLoaded: false,
      selectedQueues: [] as QueueStatus[],
      tableHeaders: [] as DataTableHeader[],
    };
  },
  created() {
    this.refreshQueues();
  },

  mounted() {
    this.tableHeaders = this.getTableHeaders();
  },

  computed: {
    ...mapState<UserState>('userStore', {
      queueEditor: 'queueEditor',
    }),
  },

  watch: {
    queueEditor() {
      this.tableHeaders = this.getTableHeaders();
    },
  },

  methods: {
    refreshQueues() {
      this.queues = [];
      this.queuesLoaded = false;
      this.$http
        .get<never>('queue')
        .then((result: AxiosResponse<QueueStatus[]>) => {
          this.queues = result.data;
          this.queuesLoaded = true;
        })
        .catch((error: AxiosError) => {
          this.queuesLoaded = true;
          bus.$emit('alert', 'Get queues failed ', 'error', 6000, error, false);
        });
    },

    getTableHeaders(): DataTableHeader[] {
      let headers = [
        {
          text: 'Name',
          value: 'name',
          width: '200px',
        },
        {
          text: 'Status',
          value: 'status',
          width: '140px',
        },
        {
          text: 'Msg Count',
          value: 'messageCount',
          width: '100px',
          align: 'center' as 'start' | 'center' | 'end',
        },
        {
          text: 'DeadLetter Msg Count',
          value: 'deadLetterMessageCount',
          width: '140px',
          align: 'center' as 'start' | 'center' | 'end',
        },
      ];
      if (this.queueEditor) {
        headers.push({
          text: 'Action',
          value: 'action',
          width: '150px',
        });
      }
      return headers;
    },

    updateOne(isEnabled: boolean, name: string) {
      let body = [name];
      this.sendUpdate(isEnabled, body);
    },

    updateSelected(isEnabled: boolean) {
      let body =
        this.selectedQueues.length > 0 ? this.selectedQueues.map((x) => x.name) : this.queues.map((x) => x.name);
      this.sendUpdate(isEnabled, body);
    },

    sendUpdate(isEnabled: boolean, body: string[] | null) {
      this.queuesLoaded = false;
      this.$http
        .put<never, AxiosResponse<QueueStatus[]>>('queue?isEnabled=' + isEnabled, body)
        .then((response) => {
          response.data.forEach((updatedQueue) => {
            let queue = this.queues.find((x) => x.name === updatedQueue.name);
            if (queue) {
              queue.status = updatedQueue.status;
            }
          });
          this.selectedQueues = [] as QueueStatus[];
          this.queuesLoaded = true;
        })
        .catch((error: AxiosError) => {
          bus.$emit('alert', 'Update queue failed ', 'error', 6000, error, false);
        });
    },

    getStatusName(status: number) {
      return EntityStatus[status];
    },

    enablePauseAll() {
      let queuesToPause = this.selectedQueues.length > 0 ? this.selectedQueues : this.queues;
      return queuesToPause.some((x) => x.status === EntityStatus.Active);
    },

    enableResumeAll() {
      let queuesToResume = this.selectedQueues.length > 0 ? this.selectedQueues : this.queues;
      return queuesToResume.some((x) => x.status === EntityStatus['Receive Disabled']);
    },
  },
});

export default Queues;
